var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"height-100per"},[_c('v-main',{staticClass:"height-100per"},[(_vm.showPopup)?_c('loading-app-popup'):_vm._e(),(_vm.showNavbar)?_c('Navbar'):_vm._e(),_c('router-view',{style:(_vm.routerViewStyle)}),(_vm.showFooter)?_c('footerComponent'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }